import { Box, Typography } from '@mui/material';
import FlexBox from 'components/shared/FlexBox';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { formatPrice } from 'utils/numberFormatter';
import useQuotationSummarySWR from '../../../../hooks/quotations/useQuotationSummarySWR';
import { TableLoadingLayout } from '../../../layouts/LoadingLayouts/TableLoadingLayout';
import { QuotationDetailsActions } from '../../../quotation-details/QuotationDetailsActions';
import { QuotationDetailsData } from '../../../quotation-details/QuotationDetailsData';
import { QuotationDetailsSummary } from '../../../quotation-details/QuotationDetailsSummary';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { QuotationSummaryProducts } from '../../../shared/quotation/quotation-products/QuotationSummaryProducts';
import { ErrorTypography } from '../../../styled/ErrorTypography';
import { QuotationDetailsDataItem } from '../../../quotation-details/QuotationDetailsDataItem';
import IfCondition from '../../../shared/IfCondition';
import React from 'react';

export const QuotationDetails = () => {
    const { quoteId } = useParams();

    const { quote, isLoading, isError } = useQuotationSummarySWR(quoteId);

    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_DETAILS.SUMMARY',
    });

    const { t: qt } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_DETAILS.DATA',
    });

    return (
        <>
            {!isLoading && isError && (
                <ErrorTypography errorCode={'QUOTATION_DETAILS_ERROR'} />
            )}
            {isLoading && <TableLoadingLayout />}
            {!isLoading && quote && (
                <>
                    <PageTitle>{quote.name}</PageTitle>
                    <QuotationDetailsActions quote={quote} />
                    <QuotationDetailsSummary quote={quote} />
                    <QuotationDetailsData quote={quote} />
                    <Box
                        sx={{
                            border: '1px solid #DAE1E7',
                            padding: '10px',
                        }}
                    >
                        <QuotationSummaryProducts quoteData={quote} />
                    </Box>
                    <Box
                        sx={{
                            paddingTop: '30px',
                            paddingBottom: '20px',
                        }}
                    >
                        <IfCondition condition={!!quote.comment_2}>
                            <QuotationDetailsDataItem title={qt('COMMENT_2')}>
                                <Typography>{quote.comment_2}</Typography>
                            </QuotationDetailsDataItem>
                        </IfCondition>
                    </Box>
                    <FlexBox justifyContent="flex-end">
                        <Box paddingY="24px">
                            {t('TOTAL_MARGIN')}:{' '}
                            <b>
                                {formatPrice(
                                    quote.items.reduce((sum, item) => {
                                        sum += item.margin * item.quantity;
                                        return sum;
                                    }, 0)
                                )}{' '}
                                Ft
                            </b>
                        </Box>
                    </FlexBox>
                </>
            )}
        </>
    );
};
